import React, { useEffect, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import TableChartOutlinedIcon from "@material-ui/icons/TableChartOutlined";

import Typography from "@material-ui/core/Typography";
import {
  Card,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Slider,
  Tooltip,
} from "@material-ui/core";
import DataService from "../../../Service";
import Loader from "../../../Components/Loader";
import useDebounce from "../../../Components/debounce";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";

import {
  AddCircleOutlined,
  ArrowDropDown,
  Close,
  Search,
} from "@material-ui/icons";
// import NDA from '../Partner/NDA';
// import OtherQuestions from '../Partner/OtherQuestions';
import MaterialTable from "material-table";
import AdminPartnerClient from "../../../Service/Admin/partner_services";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  DELETE_STEPPER_DATA,
  GLOBAL_STEPPER_DATA,
} from "../../../Redux/actions";
import HeaderMenu from "../../../Components/HeaderMenu";
import InputBase from "@material-ui/core/InputBase";
import SaveAlt from "@material-ui/icons/SaveAlt";
import { forwardRef } from "react";
import {
  ObjectToFormdata,
  TooltipWrapper,
} from "../../../Common/Utils/common_utils";
import ExportSelector from "../Organization/ManageInfo/ExportSelector";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CustomInput from "../../../Components/CustomInput";
import { mappedKeyJSON } from "../StepperComponent/MappedKeyJSON";
import CustomMultiSelectCoach from "../Coach/Shared/CustomMultiSelectCoach";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import CoachService from "../Coach/coach_service";
import { updateSearchValue } from "../../../Common/constant";

const useStyles = makeStyles((theme) => ({
  bgGray: {
    backgroundColor: "#F5F6FA",
    padding: 10,
  },
  wrapper: {
    backgroundColor: "#fff",
    borderRadius: "4px",
    padding: theme.spacing(1, 2),
    border: "1px solid #d5d5d5",
    marginLeft: "73px",
    marginBottom: "30px",
    paddingLeft: "2px",
    paddingTop: "3px",
    paddingBottom: "8px",
    width: "32%",
    height: "40px",
  },
  f12: { fontSize: 12 },
  btnSearch: {
    // backgroundColor: theme.palette.secondary.main,
    // background:"white",
    textTransform: "none",
    fontSize: 14,
  },
  root: {
    padding: "5px 4px",
    // display: 'flex',
    alignItems: "center",
    // width: 400,
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: "none",
    borderRadius: "0",
    // height: 100,
    // borderRadius: "4px",
  },
  categoryBox: {
    border: "1px solid #981B1E",
    padding: 2,
    marginTop: 2,
    marginBottom: 2,
    marginRight: 5,
    marginLeft: 5,
    borderRadius: 2,
    display: "-webkit-inline-box",
  },
  categoryTitle: {
    color: "#981B1E",
    fontSize: 14,
    padding: 5,
  },
  categoryDetail: {
    color: "#232323",
    fontSize: 14,
    paddingRight: 5,
  },
  categoryicon: {
    fontSize: 12,
    color: "#981B1E",
  },
}));
const tableIcons = {
  Export: forwardRef((props, ref) => (
    <Box style={{ marginRight: "1rem" }}>
      {" "}
      <SaveAlt style={{ color: "#EF7000" }} {...props} ref={ref} />{" "}
    </Box>
  )),
};
const createOrganisationListLayout = {
  width: "90%",
  margin: "0 auto",
  // marginTop: "80px",
};

function PartnerList() {
  // const global_data = useSelector((state) => state.stepperReducer);
  const history = useHistory();
  const classes = useStyles();

  var data = [
    {
      label: "",
      obj: [
        {
          name: "Type of partner",
          matchKey: mappedKeyJSON.TypeOfPartner,
          values: [],
        },
        {
          name: "What levels do you coach at?",
          matchKey: mappedKeyJSON.Level,
          values: [],
        },
        {
          name: "Candidate status",
          matchKey: mappedKeyJSON.Label,
          values: [],
        },
        {
          name: "Organisation",
          matchKey: mappedKeyJSON.Organisation,
          values: [],
        },
        {
          name: "Client specific levels available for",
          matchKey: mappedKeyJSON.MostSeniorRoleHeld,
          values: [],
        },
        {
          name: "Name",
          matchKey: mappedKeyJSON.FullName,
          values: [],
        },
        {
          name: "Country",
          matchKey: mappedKeyJSON.Country,
          values: [],
        },
        {
          name: "City",
          matchKey: mappedKeyJSON.City,
          values: [],
        },
        {
          name: "Business post/zip code",
          matchKey: mappedKeyJSON.BusinessZipCode,
          values: [],
        },
        {
          name: "Location/Radius",
          matchKey: mappedKeyJSON.LocationRadius,
          values: [],
        },
        {
          name: "Languages",
          matchKey: mappedKeyJSON.Language,
          values: [],
        },
        {
          name: "Coaching areas of expertise",
          matchKey: mappedKeyJSON.CoachingAreasOfExpertise,
          values: [],
        },
        {
          name: "Most senior role held",
          matchKey: mappedKeyJSON.MostSeniorRoleHeld,
          values: [],
        },
        {
          name: "Disciplines worked in",
          matchKey: mappedKeyJSON.Discipline,
          values: [],
        },
        {
          name: "Coaching clients",
          matchKey: mappedKeyJSON.RepresentativeClients,
          values: [],
        },
        {
          name: "Psychometric and diagnostic tools",
          matchKey: mappedKeyJSON.DiagnosticTools,
          values: [],
        },
        {
          name: "Client areas of expertise",
          matchKey: mappedKeyJSON.CoachingSpecificAreasOfExpertise,
          values: [],
        },
        {
          name: "Industry sectors worked in",
          matchKey: mappedKeyJSON.SectorExperience,
          values: [],
        },
        {
          name: "Industry sectors delivered in",
          matchKey: mappedKeyJSON.IndustrySector,
          values: [],
        },
        {
          name: "Facilitation area of expertise",
          matchKey: mappedKeyJSON.FacilitationAreasOfExpertise,
          values: [],
        },
        {
          name: "Faciliation clients",
          matchKey: mappedKeyJSON.FacilitationClients,
          values: [],
        },
        {
          name: "Types of Assessments",
          matchKey: mappedKeyJSON.TypeOfAssessment,
          values: [],
        },
        {
          name: "Assessment clients",
          matchKey: mappedKeyJSON.AssessmentClients,
          values: [],
        },
        {
          name: "Worked in the public sector",
          matchKey: mappedKeyJSON.WorkedInPublicSector,
          values: [],
        },
        {
          name: "Worked in the private sector",
          matchKey: mappedKeyJSON.WorkedInPrivateSector,
          values: [],
        },
        {
          name: "Minimum coach rates",
          matchKey: mappedKeyJSON.CoachingHourRate,
          values: [],
        },
        {
          name: "Coaching program rates",
          matchKey: mappedKeyJSON.CoachingProgrammeRate,
          values: [],
        },
        {
          name: "Facilitation day rates",
          matchKey: mappedKeyJSON.facilitationDayRate,
          values: [],
        },
        {
          name: "Coaching hourly rate range",
          matchKey: mappedKeyJSON.CoachingHourlyRateRange,
          values: [],
        },
        {
          name: "Date created",
          matchKey: mappedKeyJSON.CreatedAt,
          values: [],
        },
        {
          name: "Source",
          matchKey: mappedKeyJSON.SourceReferral1Id,
          values: [],
        },
      ],
    },
    // {
    //   label: "",
    //   obj: [
    //     // {
    //     //   name: "Client specific levels available for",
    //     //   matchKey: mappedKeyJSON.MostSeniorRoleHeld,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Name",
    //     //   matchKey: mappedKeyJSON.FullName,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Country",
    //     //   matchKey: mappedKeyJSON.Country,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "City",
    //     //   matchKey: mappedKeyJSON.City,
    //     //   values: [],
    //     // },
    //   ],
    // },
    // {
    //   label: "",
    //   obj: [
    //     // {
    //     //   name: "Business post/zip code",
    //     //   matchKey: mappedKeyJSON.BusinessZipCode,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Location/Radius",
    //     //   matchKey: mappedKeyJSON.LocationRadius,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Languages",
    //     //   matchKey: mappedKeyJSON.Language,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Coaching areas of expertise",
    //     //   matchKey: mappedKeyJSON.CoachingAreasOfExpertise,
    //     //   values: [],
    //     // },
    //   ],
    // },
    // {
    //   label: "",
    //   obj: [
    //     // {
    //     //   name: "Most senior role held",
    //     //   matchKey: mappedKeyJSON.MostSeniorRoleHeld,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Disciplines worked in",
    //     //   matchKey: mappedKeyJSON.Discipline,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Coaching clients",
    //     //   matchKey: mappedKeyJSON.RepresentativeClients,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Psychometric and diagnostic tools",
    //     //   matchKey: mappedKeyJSON.DiagnosticTools,
    //     //   values: [],
    //     // },
    //   ],
    // },
    // {
    //   label: "",
    //   obj: [
    //     // {
    //     //   name: "<Client> areas of expertise",
    //     //   matchKey: mappedKeyJSON.CreatedAt,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Industry sectors worked in",
    //     //   matchKey: mappedKeyJSON.SectorExperience,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Industry sectors delivered in",
    //     //   matchKey: mappedKeyJSON.IndustrySector,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Facilitation areas of expertise",
    //     //   matchKey: mappedKeyJSON.FacilitationAreasOfExpertise,
    //     //   values: [],
    //     // },
    //   ],
    // },
    // {
    //   label: "",
    //   obj: [
    //     // {
    //     //   name: "Faciliation clients",
    //     //   matchKey: mappedKeyJSON.FacilitationClients,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Types of Assessments",
    //     //   matchKey: mappedKeyJSON.TypeOfAssessment,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Assessment clients",
    //     //   matchKey: mappedKeyJSON.AssessmentClients,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Worked in the public sector",
    //     //   matchKey: mappedKeyJSON.WorkedInPublicSector,
    //     //   values: [],
    //     // },
    //   ],
    // },
    // {
    //   label: "",
    //   obj: [
    //     // {
    //     //   name: "Worked in the private sector",
    //     //   matchKey: mappedKeyJSON.WorkedInPrivateSector,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Minimum coach rates",
    //     //   matchKey: mappedKeyJSON.CoachingHourRate,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Coaching program rates",
    //     //   matchKey: mappedKeyJSON.CoachingProgrammeRate,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Facilitation day rates",
    //     //   matchKey: mappedKeyJSON.facilitationDayRate,
    //     //   values: [],
    //     // },
    //   ],
    // },
    // {
    //   label: "",
    //   obj: [
    //     // {
    //     //   name: "Coaching hourly rate range",
    //     //   matchKey: mappedKeyJSON.CreatedAt,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Date created",
    //     //   matchKey: mappedKeyJSON.CreatedAt,
    //     //   values: [],
    //     // },
    //     // {
    //     //   name: "Source",
    //     //   matchKey: mappedKeyJSON.SourceReferral1Id,
    //     //   values: [],
    //     // },
    //   ],
    // },
  ];
  const removeFilterData = (e) => {
    var pdata = {};
    for (const key in selectedFilter) {
      if (Object.prototype.hasOwnProperty.call(selectedFilter, key)) {
        const element = selectedFilter[key];
        e !== key && (pdata[key] = element);
      }
    }
    setSelectedFilter(pdata);
    setSelectedSendData(pdata);
  };
  const nameFinder = (specificRowData, specificUserData) => {
    const existingData = specificUserData.find(
      (item) =>
        item.id !== specificRowData.id &&
        item?.first_name?.trim().toLowerCase() ===
          specificRowData?.first_name?.trim().toLowerCase() &&
        item?.last_name?.trim().toLowerCase() ===
          specificRowData?.last_name?.trim().toLowerCase()
    );

    return existingData
      ? `${specificRowData.first_name} ${specificRowData.middle_name} ${specificRowData.last_name}`
      : `${specificRowData.first_name} ${specificRowData.last_name}`;
  };
  const clearAllFilterHandler = () => {
    setSelectedFilter({});
  };

  const [userData, setUserData] = useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  // const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [isGridVisible, setIsGridVisible] = useState(false);
  const [partnerDummyRoleArr, setPartnerDummyRoleArr] = useState([]);
  const [dynamicDropdownValue, setDynamicDropdownValue] = useState([]);
  const [updatedData, setupdatedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFilter, setSelectedFilter] = useState({
    organisation_id: {
      name: "Organisation",
      selectedValue: "All",
      selectedValueId: ["ALL"],
      defaultValue: [{ title: "All", id: "ALL" }],
    },
    coaching_hr_id: {
      name: "Minimum coach rates",
      selectedValue: "All",
      selectedValueId: ["ALL"],
      defaultValue: [{ title: "All", id: "ALL" }],
    },
    coaching_programme_rate_id: {
      name: "Coaching program rates",
      selectedValue: "All",
      selectedValueId: ["ALL"],
      defaultValue: [{ title: "All", id: "ALL" }],
    },
    assessment_hour_rate_id: {
      name: "Assessment program rates",
      selectedValue: "All",
      selectedValueId: ["ALL"],
      defaultValue: [{ title: "All", id: "ALL" }],
    },
    mentoring_day_rate_id: {
      name: "Mentoring program rates",
      selectedValue: "All",
      selectedValueId: ["ALL"],
      defaultValue: [{ title: "All", id: "ALL" }],
    },
    facilitation_day_rate_id: {
      name: "Facilitation program rates",
      selectedValue: "All",
      selectedValueId: ["ALL"],
      defaultValue: [{ title: "All", id: "ALL" }],
    },
    currency: {
      name: "Currency",
      selectedValue: "All",
      selectedValueId: ["ALL"],
      defaultValue: [{ title: "All", id: "ALL" }],
    },
  });
  const [selectedSendData, setSelectedSendData] = useState([]);
  const [locationDropdownFlag, setLocationDropdownFlag] = useState(false);
  const [additionalFilter, setAdditionalFilter] = useState(false);
  const [partnerRolesArr, setPartnerRolesArr] = useState([]);

  const searchLogic = () => {
    var pdata = {};
    for (const key in selectedFilter) {
      if (key === "location_radius") {
        let temp = String(selectedFilter[key]);
        let finalValue = temp.split();
        pdata[key] = finalValue;
      } else if (key === "business_postcode") {
        let temp = String(selectedFilter[key]);
        let finalValue = temp.split();
        pdata[key] = finalValue;
      } else if (key === "department_list_id") {
        pdata["magic20_associate_id"] = selectedFilter[key]["selectedValueId"]
          .toString()
          .split(",");
      } else if (key === "mentoring_day_rate_id") {
        pdata["mentoring_day_rate_id"] = selectedFilter[key]["selectedValueId"];
      } else if (key === "coaching_programme_rate_id") {
        pdata["coaching_programme_rate_id"] =
          selectedFilter[key]["selectedValueId"];
      } else pdata[key] = selectedFilter[key]["selectedValueId"];
    }
    Object.keys(pdata).forEach((itemKey) => {
      const array = pdata[itemKey];

      // Filter out undefined elements
      const filteredArray = array.filter((el) => el);

      if (filteredArray.length === 0) {
        // If the filtered array is empty, delete the property
        delete pdata[itemKey];
      } else {
        // Otherwise, update the property with the filtered array
        pdata[itemKey] = filteredArray;
      }
    });

    var localRoleArr = [];
    partnerRolesArr.map((option) => localRoleArr.push(option.id));
    // setIsGridVisible(false);
    setResetFilter();
    setLoading(true);

    CoachService.coachSearch(
      ObjectToFormdata({
        role_id: JSON.stringify(localRoleArr),
        search_term: searchQuery,
        search_query: " ",
        search_attributes: JSON.stringify({ ...pdata }),
        search_type: "External",
      })
    )
      .then((response) => {
        userData.length = 0;
        if (response.errors) {
          setUserData([]);
          dispatch(showSnackbar("error", ["" + response.errors]));
        } else {
          setSearchQuery("");
          setUserData(response.data);
        }
      })
      .catch((error) => {
        userData.length = 0;
        setUserData([]);
        dispatch(showSnackbar("error", ["Some error occured!"]));
      })
      .finally(() => setLoading(false));
  };

  const filterData = useMemo(() => {
    return Object.keys(selectedFilter).map((key) => {
      return (
        <React.Fragment>
          {key === "business_postcode" && (
            <div className={classes.categoryBox}>
              <label className={classes.categoryTitle}>
                Business post/zip code:
              </label>
              <label className={classes.categoryDetail}>
                {selectedFilter[key]}
              </label>
              <Close
                onClick={() => {
                  removeFilterData(key);
                }}
                className={classes.categoryicon}
              />
            </div>
          )}

          {key === "location_radius" ? (
            <div className={classes.categoryBox}>
              <label className={classes.categoryTitle}>Location/Radius:</label>
              <label className={classes.categoryDetail}>
                {selectedFilter[key]}
              </label>
              <Close
                onClick={() => {
                  removeFilterData(key);
                }}
                className={classes.categoryicon}
              />
            </div>
          ) : (
            key !== "business_postcode" && (
              <div className={classes.categoryBox}>
                <label className={classes.categoryTitle}>
                  {selectedFilter[key]["name"]}:
                </label>
                <label className={classes.categoryDetail}>
                  {selectedFilter[key]["selectedValue"]}
                </label>
                <Close
                  onClick={() => {
                    removeFilterData(key);
                  }}
                  className={classes.categoryicon}
                />
              </div>
            )
          )}
        </React.Fragment>
      );
    });
  }, [selectedFilter, selectedSendData]);

  useEffect(() => {
    getListingDropdowns();
  }, []);

  const getListingDropdowns = () => {
    AdminPartnerClient.dropdown_get("listingDropdowns", {
      // assignment_id: props.location.state.currentAssignment.id,
    }).then((response) => {
      partnerDummyRoleArr.length = 0;
      var pdata = [
        ...response[mappedKeyJSON.Role],
        { id: response[mappedKeyJSON.Role] + 1, value: "Add New" },
      ];
      setPartnerDummyRoleArr(partnerDummyRoleArr.concat(pdata));

      data?.map((option) => {
        option.obj.map((e) => {
          var localArr = [];
          response[e.matchKey]?.map((subOption, subOptIndex) => {
            var pdata = {
              title: subOption.value == null ? "" : subOption.value,
              id: subOption.id,
            };
            subOptIndex === 0 && option.label === "Organization"
              ? localArr.push({
                  title: "All",
                  id: "ALL",
                }) && localArr.push(pdata)
              : localArr.push(pdata);
          });
          e.values = localArr;
        });
      });
      dynamicDropdownValue.length = 0;
      setDynamicDropdownValue(dynamicDropdownValue.concat(data[0]));
      setupdatedData(updatedData.concat(data));
    });
  };

  const handleChange = (event, newValue) => {
    // setUserData({ ...userData, location_radius: newValue });

    setSelectedFilter({ ...selectedFilter, location_radius: newValue });
  };

  const handleInputChange = (inputStateValue, inputId, index) => {
    setSelectedFilter({ ...selectedFilter, [inputId]: inputStateValue });
  };

  const onChangeMultipleItem = (inputStateValue, inputId, event) => {
    var pdata = selectedFilter;
    const newValue = inputStateValue[inputStateValue.length - 1];
    if (inputStateValue.length > 0) {
      pdata[inputId.matchKey] = {
        name: inputId.name,
        selectedValue:
          newValue.id === "ALL"
            ? "All"
            : inputStateValue
                .filter((option) => option.title !== "All")
                .map((el) => el.title)
                .join(","),
        selectedValueId:
          newValue.id === "ALL"
            ? ["ALL"]
            : inputStateValue
                .filter((option) => option.id !== "ALL")
                .map((el) => el.id),
        defaultValue:
          newValue.id === "ALL"
            ? [
                {
                  title: "All",
                  id: "ALL",
                },
              ]
            : inputStateValue.filter((option) => option.id !== "ALL"),
      };
      setSelectedFilter({ ...selectedFilter, ...pdata });
    } else {
      removeFilterData(inputId.matchKey);
    }
  };

  const setResetFilter = () => {
    setAdditionalFilter(!additionalFilter);
    if (additionalFilter) {
      dynamicDropdownValue.length = 0;
      setDynamicDropdownValue(dynamicDropdownValue.concat(updatedData[0]));
    } else {
      dynamicDropdownValue.length = 0;
      setDynamicDropdownValue(dynamicDropdownValue.concat(updatedData));
    }
  };

  const handleButtonClick = () => {
    setIsGridVisible(true);
  };

  const searchValue = useSelector((state) => state?.commonReducer?.searchValue);
  const [searchTextSelect, setSearchTextSelect] = useState(null);

  const handleSearchText = (event) => {
    const newValue = event?.target?.value;
    setSearchTextSelect(newValue);
    // dispatch(updateSearchValue(newValue));
  };

  const debouncedSearchText = useDebounce(searchTextSelect, 700);
  const type = "Partner";
  const createTypeRoute =
    type === "Partner"
      ? "/admin/partner/onboarding"
      : type === "Organizaion"
      ? "/admin/organisation/create"
      : "";

  const getData = () => {
    setLoading(true);
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      search: debouncedSearchText || searchTextSelect || null,
    };
    DataService.getDirectData(`/partner_profiles`, params)
      .then((response) => {
        let listData = response["partner_profiles"];
        setUserData(listData);
        setTotalCount(response.total_count);
        setLoading(false);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (searchValue) {
      setSearchTextSelect(searchValue);
      dispatch(updateSearchValue(""));
    } else {
      setLoading(true);
      getData();
    }
  }, [page, pageSize, debouncedSearchText, searchValue]);

  const [isDownloadAllLoading, setIsDownloadAllLoading] = useState(false);

  const [isDownloadIndividual, setIsDownloadIndividual] = useState({
    isLoading: false,
    downloadingOption: "",
  });
  const handleDownloadAll = (event) => {
    setIsDownloadAllLoading(true);

    DataService.getDirectData("partner_profiles/partner_data_download")
      .then((res) => {
        dispatch(showSnackbar("success", ["Downloaded successfully "], 1000));
        window.location.assign(res.file);
      })
      .catch((error) => {
        dispatch(showSnackbar("error", ["No data found!"], 1000));
      })
      .finally(() => {
        setIsDownloadAllLoading(false);
      });
  };
  const handleDownloadIndividual = (option) => {
    const { id: optionId, full_name: optionName } = option;
    setIsDownloadIndividual({
      isLoading: true,
      downloadingOption: optionId,
    });
    const params = { partner_profile_id: optionId };
    DataService.getDirectData("partner_profiles/partner_data_download", params)
      .then((res) => {
        dispatch(
          showSnackbar(
            "success",
            ["Downloaded successfully " + optionName],
            1000
          )
        );
        window.location.assign(res.file);
      })
      .catch((error) => {
        dispatch(showSnackbar("error", ["No data found!"], 1000));
      })
      .finally(() => {
        setIsDownloadIndividual({ isLoading: false, downloadingOption: "" });
      });
  };

  const columns = [
    {
      field: "id",
      title: "ID",
      export: true,
      hidden: true,
      notExportable: true,
    },
    {
      field: "full_name",
      title: "Name",
      headerStyle: {
        textAlign: "left",
        padding: "10px 26px",
        color: "#077f83",
      },

      cellStyle: {
        textAlign: "left",
        padding: "10px 26px",
      },
      render: (rowData) => {
        return nameFinder(rowData, userData);
      },
    },
    {
      notExportable: true,
      title: "Coaching Profile",
      headerStyle: {
        textAlign: "center",
        padding: "10px 26px",
        color: "#077f83",
      },
      cellStyle: {
        textAlign: "center",
        padding: "10px 26px",
      },
      sorting: false,
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            gap: "8px",
            justifyContent: "center",
          }}
        >
          {rowData?.roles.includes("Executive Coach") ? (
            <VisibilityIcon
              style={{
                cursor: "pointer",
                marginLeft: "-16px",
                fontSize: "20px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                history.push("/CoachDetail", {
                  id: rowData.id,
                  coachType: "external",
                  currentSelection: rowData?.roles.includes("Executive Coach"),
                  selectedRole: rowData?.roles.includes("Executive Coach")
                    ? "Executive Coach"
                    : "",
                });
              }}
            />
          ) : (
            ""
          )}
        </div>
      ),
    },
    {
      notExportable: true,
      title: "Facilitation profile",
      headerStyle: {
        textAlign: "center",
        padding: "10px 26px",
        color: "#077f83",
      },

      cellStyle: {
        textAlign: "center",
        padding: "10px 26px",
      },
      sorting: false,
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            gap: "8px",
            justifyContent: "center",
          }}
        >
          {rowData?.roles.includes("Facilitator") ? (
            <VisibilityIcon
              style={{
                cursor: "pointer",
                marginLeft: "-16px",
                fontSize: "20px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                history.push("/CoachDetail", {
                  id: rowData.id,
                  coachType: "external",
                  currentSelection: rowData,
                  selectedRole: rowData?.roles.includes("Facilitator")
                    ? "Facilitator"
                    : "",
                });
              }}
            />
          ) : (
            ""
          )}
        </div>
      ),
    },
    {
      notExportable: true,
      title: "Mentoring profile",
      headerStyle: {
        textAlign: "center",
        padding: "10px 26px",
        color: "#077f83",
      },
      sorting: false,

      cellStyle: {
        textAlign: "center",
        padding: "10px 26px",
      },
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            gap: "8px",
            justifyContent: "center",
          }}
        >
          {rowData?.roles.includes("Mentor") ? (
            <VisibilityIcon
              style={{
                cursor: "pointer",
                marginLeft: "-16px",
                fontSize: "20px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                history.push("/CoachDetail", {
                  id: rowData.id,
                  coachType: "external",
                  currentSelection: rowData,
                  selectedRole: rowData?.roles.includes("Mentor")
                    ? "Mentor"
                    : "",
                });
              }}
            />
          ) : (
            ""
          )}
        </div>
      ),
    },
    {
      notExportable: true,
      title: "Assessment profile",
      headerStyle: {
        textAlign: "center",
        padding: "10px 26px",
        color: "#077f83",
      },
      sorting: false,
      cellStyle: {
        textAlign: "center",
        padding: "10px 26px",
      },
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            gap: "8px",
            justifyContent: "center",
          }}
        >
          {rowData?.roles.includes("Assessor") ? (
            <VisibilityIcon
              style={{
                cursor: "pointer",
                marginLeft: "-16px",
                fontSize: "20px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                history.push("/CoachDetail", {
                  id: rowData.id,
                  coachType: "external",
                  // currentSelection: "Assessor",
                  selectedRole: rowData?.roles.includes("Assessor")
                    ? "Assessor"
                    : "",
                });
              }}
            />
          ) : (
            ""
          )}
        </div>
      ),
    },
    {
      title: "Partner details",
      headerStyle: {
        textAlign: "center",
        padding: "10px 26px",
        color: "#077f83",
      },
      cellStyle: {
        textAlign: "right",
        paddingRight: "60px",
      },
      sorting: false,
      notExportable: true,
      render: (rowData) => (
        <Button
          disableElevation
          variant="outlined"
          color="#F1ECED"
          size="small"
          style={{ textTransform: "none" }}
          onClick={() => {
            dispatch({
              type: GLOBAL_STEPPER_DATA,
              payload: { partner_profile: rowData.id },
            });
            dispatch(updateSearchValue(searchTextSelect));

            history.push(createTypeRoute);
          }}
        >
          View
        </Button>
      ),
    },
    {
      notExportable: true,
      width: "15px",
      render: (rowData) => {
        return (
          <Tooltip
            title={
              <TooltipWrapper
                text={
                  isDownloadIndividual.isLoading &&
                  isDownloadIndividual.downloadingOption === rowData.id
                    ? `Downloading ${
                        nameFinder(rowData, userData) || ""
                      } records`
                    : `Download ${nameFinder(rowData, userData) || ""} records`
                }
              />
            }
          >
            <IconButton
              onClick={(event) => {
                handleDownloadIndividual(rowData);
              }}
              disabled={
                isDownloadIndividual.isLoading &&
                isDownloadIndividual.downloadingOption !== rowData.id
              }
            >
              {isDownloadIndividual.isLoading &&
              isDownloadIndividual.downloadingOption === rowData.id ? (
                <CircularProgress size={20} color="secondary" />
              ) : (
                <SaveAlt style={{ height: "01.5rem" }} color="secondary" />
              )}
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];
  const options = {
    exportButton: false,
    search: false,
    exportFileName: "partner_list",
    emptyRowsWhenPaging: false,
    exportDelimiter: ",",
    searchFieldAlignment: "right",
    total: totalCount,
    exportAllData: true,

    // page:page,
    pageSize: pageSize,
    pageSizeOptions: [20, 50, 75, 100],
    headerStyle: {
      position: "sticky",
      top: "0",
      fontWeight: "800",
    },
    maxBodyHeight: "600px",
  };

  // const theme = createMuiTheme({
  //     overrides: {
  //         // MuiToolbar: {
  //         //   root: {
  //         //     backgroundColor: "#f1eded",
  //         //   },
  //         // },
  //         MUIDataTablePagination: {
  //             tableCellContainer: {
  //                 padding: "0px",
  //             },
  //             navContainer: {
  //                 backgroundColor: "#f1eded",
  //             },
  //         },
  //         MUIDataTableHeadCell: {
  //             fixedHeader: {
  //                 backgroundColor: "#f1eded",
  //             }
  //         }
  //     },

  // });

  return (
    <>
      <HeaderMenu />
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        style={{
          paddingTop: 30,
          paddingBottom: 30,
          paddingLeft: 80,
          paddingRight: 80,
        }}
      >
        <Grid item xs={6} style={{ textAlign: "left" }}>
          <Typography
            style={{
              fontSize: 26,
              lineHeight: "30px",
              fontWeight: "bold",
              color: "#077f83",
            }}
          >
            All partners
          </Typography>
        </Grid>
        <Grid item xs={6} style={{ textAlign: "right" }}>
          <Button
            disableElevation
            variant="contained"
            color="secondary"
            onClick={() => {
              dispatch({ type: DELETE_STEPPER_DATA });
              history.push(createTypeRoute, {
                type: "create",
              });
            }}
            style={{ textTransform: "none" }}
          >
            <AddCircleOutlined
              style={{ marginRight: 10, fontSize: 15, marginLeft: "16px" }}
            />
            Create{" "}
            <span style={{ textTransform: "lowercase", paddingLeft: 4 }}>
              {type}
            </span>
          </Button>
          {!isGridVisible ? (
            <Button
              disableElevation
              variant="contained"
              color="secondary"
              style={{
                marginLeft: "16px",
              }}
              // startIcon={<Search />}
              onClick={handleButtonClick}
              className={classes.btnSearch}
            >
              Partner search
            </Button>
          ) : null}
        </Grid>
      </Grid>
      {!isGridVisible ? (
        <div className={classes.wrapper}>
          <InputBase
            fullWidth
            style={{ height: 50, paddingLeft: 10 }}
            placeholder={"Search anything"}
            value={searchTextSelect}
            // value={searchValue}
            onChange={handleSearchText}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
          />
        </div>
      ) : null}

      {isGridVisible && (
        <>
          <Grid
            container
            alignItems="center"
            justify="center"
            style={{ maxWidth: "92.75%", margin: "0 auto" }}
          >
            <Grid item xs={12} style={{ padding: "20px" }}>
              <Paper
                component="form"
                variant="outlined"
                style={{
                  backgroundColor: "#077f837a",
                  border: "none",
                  paddingLeft: "20px",
                }}
              >
                <Close
                  style={{ marginLeft: "10px", paddingTop: "10px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsGridVisible(false);
                  }}
                />
                <Grid
                  container
                  alignItems="center"
                  spacing={2}
                  style={{ paddingRight: "20px" }}
                >
                  <Grid item xs={7}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-start"
                      gap="0.25rem"
                      border="1px solid black"
                      borderRadius="4px"
                      bgcolor="white"
                      margin="20px"
                    >
                      <IconButton aria-label="search">
                        <Search />
                      </IconButton>
                      {/* <InputBase
                        autoFocus
                        placeholder='Search'
                        inputProps={{
                          "aria-label": "search",
                          style: {
                            marginTop: "0.25rem",
                          },
                        }}
                        value={searchTextSelect}
                        onChange={(e) => handleSearchText(e.target.value)}
                      /> */}
                      <InputBase
                        className={classes.input}
                        placeholder="Search"
                        // onChange={(e) => {
                        //   setSearchQuery(e.target.value);
                        // }}
                        inputProps={{ "aria-label": "search" }}
                        value={searchTextSelect}
                        // value={searchValue}
                        onChange={handleSearchText}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      variant="contained"
                      color="secondary"
                      style={{
                        width: "100%",
                        textTransform: "capitalize",
                      }}
                      onClick={() => searchLogic()}
                    >
                      Search
                    </Button>
                  </Grid>
                  <Grid item xs={3}>
                    {/* <Button
                      disableElevation
                      onClick={setResetFilter}
                      variant='contained'
                      color='secondary'
                      className={classes.btnAdditional}
                      style={{ textTransform: "none" }}
                    >
                      {additionalFilter ? "Hide" : "Show"} additional filters
                    </Button> */}
                  </Grid>
                  {Object.keys(selectedFilter).length > 0 && (
                    <Grid
                      container
                      direction="row"
                      alignItems="flex-start"
                      style={{ marginBottom: 20 }}
                    >
                      <Grid item xs={12}>
                        <Paper className={classes.root} style={{ border: 0 }}>
                          <Grid container direction="row">
                            <Grid item xs={10}>
                              {filterData}
                            </Grid>
                            <Grid item xs={2}>
                              <label
                                style={{
                                  color: "#981B1E",
                                  fontSize: 12,
                                  paddingLeft: 10,
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  clearAllFilterHandler();
                                }}
                              >
                                Clear all filters
                              </label>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>
                    </Grid>
                  )}
                  {dynamicDropdownValue.length > 0 &&
                    dynamicDropdownValue.map((option) => {
                      return (
                        <Grid
                          container
                          direction="row"
                          alignItems="center"
                          style={{ marginTop: 30 }}
                        >
                          <Grid item xs={12} style={{ marginBottom: 10 }}>
                            <label>
                              <Typography
                                variant="h2"
                                style={{ fontWeight: "bold" }}
                              >
                                {option.label}
                              </Typography>
                            </label>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid
                              container
                              direction="row"
                              alignItems="flex-start"
                              style={{ marginTop: "10" }}
                            >
                              {option.obj.map((e) => {
                                return (
                                  <>
                                    {e.name === "Business post code" && (
                                      <Grid
                                        item
                                        xs={3}
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "10px",
                                        }}
                                      >
                                        {/* <CustomMultiSelectCoach
                                  limitTags={1}
                                  id={e.matchKey}
                                  values={e}
                                  defaultValue={
                                    selectedFilter[e.matchKey]
                                      ?.defaultValue == undefined
                                      ? []
                                      : selectedFilter[e.matchKey]
                                          ?.defaultValue
                                  }
                                  parentcall={onChangeMultipleItem}
                                /> */}
                                        <CustomInput
                                          placeholder="Business post/zip code"
                                          className={classes.textField}
                                          style={{
                                            marginBlock: 12,
                                            backgroundColor: "white",
                                          }}
                                          id={e.matchKey}
                                          inputProps={{
                                            style: {
                                              height: "27px",
                                            },
                                          }}
                                          variant="outlined"
                                          parentcall={handleInputChange}
                                        />
                                      </Grid>
                                    )}
                                    {e.name !== "Location/Radius" &&
                                    e.name !== "Business post code" ? (
                                      <Grid
                                        item
                                        xs={3}
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "10px",
                                        }}
                                      >
                                        <CustomMultiSelectCoach
                                          limitTags={1}
                                          id={e.matchKey}
                                          values={e}
                                          defaultValue={
                                            selectedFilter[e.matchKey]
                                              ?.defaultValue === undefined
                                              ? []
                                              : selectedFilter[e.matchKey]
                                                  ?.defaultValue
                                          }
                                          parentcall={onChangeMultipleItem}
                                        />
                                      </Grid>
                                    ) : (
                                      e.name !== "Business post code" && (
                                        <Grid item xs={3}>
                                          <Card
                                            variant="outlined"
                                            style={{
                                              padding: 10,
                                              margin: 10,
                                            }}
                                          >
                                            <Grid
                                              container
                                              direction="row"
                                              alignItems="flex-start"
                                            >
                                              <Grid item xs={12}>
                                                <div
                                                  onClick={() => {
                                                    setLocationDropdownFlag(
                                                      !locationDropdownFlag
                                                    );
                                                  }}
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                    marginBottom: "0.25rem",
                                                  }}
                                                >
                                                  <label
                                                    className={
                                                      classes.locationTitle
                                                    }
                                                  >
                                                    Location/Radius (km)
                                                  </label>
                                                  <div
                                                    style={{ float: "right" }}
                                                  >
                                                    <ArrowDropDown />
                                                  </div>
                                                </div>
                                              </Grid>
                                              {locationDropdownFlag && (
                                                <>
                                                  <Grid item xs={12}>
                                                    <Slider
                                                      onChange={handleChange}
                                                      id={e.matchKey}
                                                      defaultValue={0}
                                                      aria-labelledby="continuous-slider"
                                                      step={10}
                                                      valueLabelDisplay="on"
                                                      value={
                                                        selectedFilter.location_radius
                                                      }
                                                    />
                                                  </Grid>
                                                </>
                                              )}
                                            </Grid>
                                          </Card>
                                        </Grid>
                                      )
                                    )}
                                  </>
                                );
                              })}
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                    })}
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </>
      )}

      <div style={createOrganisationListLayout}>
        <Grid xs={12} className={classes.miTable}>
          {loading && <Loader />}
          <div className={classes.miTable}>
            <MaterialTable
              title={
                <Typography variant="subtitle1" style={{ color: "#EF7000" }}>
                  Partner list
                </Typography>
              }
              actions={[
                {
                  icon: () => {
                    return (
                      <Tooltip title={<TooltipWrapper text={"Live view"} />}>
                        <TableChartOutlinedIcon
                          style={{ height: "01.5rem" }}
                          color="secondary"
                        />
                      </Tooltip>
                    );
                  },
                  isFreeAction: true,
                  onClick: () => {
                    history.push({
                      pathname: "/admin/liveView/partner",
                      state: { for: "partner" },
                    });
                  },
                },
                {
                  icon: () => {
                    const params = {
                      page: page + 1 || 1,
                      count_per_page: pageSize || 20,
                      search: debouncedSearchText || null,
                    };
                    let url = "/partner_profiles";
                    return (
                      <ExportSelector
                        params={params}
                        columns={columns}
                        url={url}
                        fileName={"Partner list"}
                        downloadKey="partner_profiles"
                        downloadText={"Download partners listing"}
                        downloadingText={"Downloading partners listing"}
                      />
                    );
                  },
                  isFreeAction: true,
                },
                {
                  icon: () => {
                    return (
                      <Tooltip
                        title={
                          <TooltipWrapper
                            text={
                              isDownloadAllLoading
                                ? "Downloading all records"
                                : "Download all records"
                            }
                          />
                        }
                      >
                        {isDownloadAllLoading ? (
                          <CircularProgress size={20} color="secondary" />
                        ) : (
                          <SaveAlt
                            style={{ height: "01.5rem" }}
                            color="secondary"
                          />
                        )}
                      </Tooltip>
                    );
                  },
                  isFreeAction: true,
                  onClick: handleDownloadAll,
                },
              ]}
              icons={tableIcons}
              data={userData}
              totalCount={totalCount}
              columns={columns}
              options={options}
              localization={{
                toolbar: {
                  exportAriaLabel: "Download as CSV ",
                  exportTitle: <TooltipWrapper text="Download as CSV" />,
                  exportName: "Download as CSV ",
                },
              }}
              onChangePage={(page) => {
                setPage(page);
              }}
              onChangeRowsPerPage={(pageSize) => {
                setPageSize(pageSize);
              }}
              onSearchChange={(search) => {
                handleSearchText(search);
              }}
            />
          </div>
        </Grid>
      </div>
    </>
  );
}

export default PartnerList;
